import React, { PureComponent } from 'react';

import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { getStore } from 'store';
import history from 'lib/history';
import { gigyaScriptLoaded, loadGigyaScript } from 'api/gigya';
import { appBoot } from 'actions/lifecycle-actions';
import DocumentMeta from 'react-document-meta';
import Schema, { generalSchema } from 'components/Schema';
import FlagsProvider from 'firebase/FlagsProvider';
import defaultRemoteConfigFlags from 'firebase/defaultRemoteConfigFlags';

import { injectStyles } from 'injectStyles';

import 'analytics/init';
import 'players/ChromeSender';

import { globalStyle, accessibilityStyleSettings } from './global-styles';
import ErrorBoundary from './ErrorBoundary';
import Layout from '../Layout';
import { baseMeta } from './App.const';
import Theme from './Theme';
import logger from 'util/logger';

const store = getStore();

// no need to wait till the interface is loaded if we can get the data already
store.dispatch(appBoot());

class App extends PureComponent {
  componentDidMount() {
    this.loadGigyaService();
    accessibilityStyleSettings();
    window.e2e = window.e2e || {};
  }

  loadGigyaService = async () => {
    if (!gigyaScriptLoaded()) {
      const apiKey = process.env.REACT_APP_GIGYA_API_KEY;
      try {
        await loadGigyaScript(apiKey);
      } catch (err) {
        logger.warn(err.message);
      }
    }
  };

  render() {
    return (
      <FlagsProvider defaults={defaultRemoteConfigFlags}>
        <Provider store={store}>
          <Theme>
            <Router history={history}>
              <ErrorBoundary>
                <DocumentMeta {...baseMeta} />
                <Schema data={generalSchema} />
                <Layout />
              </ErrorBoundary>
            </Router>
          </Theme>
        </Provider>
      </FlagsProvider>
    );
  }
}

export default injectStyles(globalStyle)(App);
